/* @flow */
import * as React from 'react';
import EventTracking from 'lib/EventTracking';
import Icon from 'components/Icon.jsx';
import Link from 'components/Link.jsx';
import Table from 'components/Table.jsx';

import type { AffectedResource } from 'admin/components/AdminSchoolSisDashboard.jsx';
import './styles/AdminSisSyncHoldViewResourceTable.scss';

type Props = {
  affectedResources: Array<AffectedResource>,
  orgUuid: string,
};

const AdminSisSyncHoldViewResourceTable = ({ affectedResources, orgUuid }: Props) => {
  const handleLinkClicked = () => {
    EventTracking.track('rostering.hold.downloaded', {
      organization_uuid: orgUuid,
    });
  };

  return (
    <section className="AdminSisSyncHoldViewResourceTable">
      <Table
        actionsColumn
        head={
          <tr>
            <th>Count</th>
            <th>Description</th>
            <th>CSV</th>
          </tr>
        }>
        <tbody>
          {affectedResources.map(i => {
            return (
              <tr key={i.downloadUrl}>
                <td className="AdminSisSyncHoldViewResourceTable-firstColumn">{i.count}</td>
                <td>{i.description}</td>
                <td>
                  <Link
                    href={i.downloadUrl}
                    target="_blank"
                    tooltip="Download CSV"
                    tooltipPlacement="left"
                    download
                    onClick={handleLinkClicked}>
                    <Icon name="arrow-down-bar" solo size="large" />
                  </Link>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </section>
  );
};

export default AdminSisSyncHoldViewResourceTable;
